<template>
  <el-form label-position="left" :model="loginInfo" style="width: 662px">
    <div class="formLogin"><img src="@/assets/img/logo.png" alt="" /></div>
    <el-form-item>
      <el-row>
        <!-- <el-col :span="3"
          ><span class="icon iconfont icon-user icon-input"></span
        ></el-col> -->
        <el-col :span="20">
          <div class="border-input">
            <el-input
              autofocus
              v-model="loginInfo.username"
              @click.native.stop.prevent="handleClick('username')"
              @touchend.native.stop.prevent="handleClick('username')"
              ><template slot="prepend"><img src="@/assets/img/user.png" alt="" /></template
            ></el-input>
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item class="margin-top-20" prop="password">
      <el-row>
        <!-- <el-col :span="3"
          ><span class="icon iconfont icon-lock icon-input"></span
        ></el-col> -->
        <el-col :span="20">
          <div class="border-input">
            <el-input
              v-model="loginInfo.password"
              @click.native.stop.prevent="handleClick('password')"
              @touchend.native.stop.prevent="handleClick('password')"
              :type="showPassword ? 'text' : 'password'"
            >
              <template slot="prepend"><img src="@/assets/img/lock.png" alt="" /></template>
              <i
                slot="suffix"
                class="password-img"
                @click.stop.prevent="switchPassword"
                @touchend.stop.prevent="switchPassword"
              >
                <img v-if="showPassword" class="input_icon" src="@/assets/img/show-view.png" />
                <img v-else class="input_icon" src="@/assets/img/hidde-view.png" />
              </i>
              <!-- <template slot="append"><img src="@/assets/img/view.png" alt=""></template> -->
            </el-input>
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item v-if="debug" class="margin-top-20">
      <el-row>
        <el-col :span="3"><span class="icon iconfont icon-server icon-input"></span></el-col>
        <el-col :span="5">
          <el-select
            class="select-http-https"
            style="width: 100%"
            v-model="loginInfo.serverssl"
            placeholder=""
          >
            <el-option label="HTTPS" :value="1"></el-option>
            <el-option label="HTTP" :value="0"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <el-input
            class="input-with-select input-server-ip"
            v-model="loginInfo.serverip"
            @click.native.stop.prevent="handleClick('serverip')"
            @touchend.native.stop.prevent="handleClick('serverip')"
          ></el-input
        ></el-col>
        <el-col :span="5">
          <el-input
            class="input-server-port"
            v-model="loginInfo.serverport"
            @click.native.stop.prevent="handleClick('serverport')"
            @touchend.native.stop.prevent="handleClick('serverport')"
          >
          </el-input
        ></el-col>
      </el-row>
    </el-form-item>
    <el-form-item class="margin-top-10">
      <div class="margin-box">
        <el-checkbox v-model="loginInfo.rememberPassword">{{
          $t("langcfg.txtRememberPassword")
        }}</el-checkbox>
      </div>
    </el-form-item>
    <el-form-item class="margin-top-30">
      <div class="btn-area">
        <el-button @click="loginClick()"
          ><span style="font-size: 35px"> &nbsp;{{ $t("langcfg.txtLogin") }}</span>
        </el-button>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import EVENTS from "../../../bus";
import { Message, Size } from "../../../mixins";
import { HTTP_ERRORS } from "../../../services/httpreq/const";
import login, { keepAlive } from "../../../services/login";
import { saveServerSettings } from "../../../settings";
import { isDefined, objectCopy } from "../../../shared/utils";
export default {
  data() {
    return {
      loginInfo: {
        username: "Admin",
        password: "",
        serverssl: 0,
        serverip: "127.0.0.1",
        serverport: 8080,
        sslport: 4430,
        rememberPassword: false
      },
      debug: window.__main__.debug,
      showPassword: false
    };
  },
  methods: {
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.loginInfo[key], (value) => {
        self.loginInfo[key] = value;
        self.loginInfo = objectCopy(self.loginInfo);
      });
    },
    loginClick() {
      // let data = {
      //   token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiI4QWFwV1kzbXczN0hOcHRKIiwidXNyIjoiQWRtaW4iLCJleHAiOjE2OTEyMDkyNzg4Mzd9.QjFq11fT6BRg1H8RzOj4sG_U8msAJo0YyZgvTViU19U',
      //   expires: 1691209278837,
      //   user: { 'username': 'Admin', 'defaultuser': '1', 'isadmin': '1', '_id': '8AapWY3mw37HNptJ' }
      // }
      login(this.loginInfo, (data) => {
        if (data.message === "OK") {
          if (this.loginInfo.rememberPassword) {
            window.localStorage.setItem("login-password", this.loginInfo.password);
          } else {
            window.localStorage.setItem("login-password", "");
          }
          const { username, serverssl, serverip, serverport, sslport, rememberPassword } =
            this.loginInfo;
          window.server = {
            username: username,
            serverssl: serverssl,
            serverip: serverip,
            serverport: serverport,
            sslport: sslport,
            rememberPassword: rememberPassword
          };
          saveServerSettings(window.server);
          if (this.isForm) {
            this.$emit("login-success");
          } else {
            this.message(this.$t("langcfg.txtLoginSuccess"), "success", 1000);
          }
        } else {
          if (data.error.code === HTTP_ERRORS.errrorUserOrPassword) {
            this.message(this.$t("langcfg.txtPasswdOrUsernameWrong"), "error", 1000);
          } else {
            this.message(this.$t("langcfg.txtFaildToLogin"), "error", 1000);
          }
        }
      });
    },
    initLogin() {
      this.loginInfo = objectCopy(window.server);
      let passwd = window.localStorage.getItem("login-password");
      this.loginInfo.password = window.server.rememberPassword ? passwd || "" : "";
    },
    switchPassword() {
      this.showPassword = !this.showPassword;
    }
  },
  mounted() {
    this.initLogin();
    // 开机自动登录
    // setTimeout(() => {
    //   this.loginClick()
    // }, 2000);
  },
  computed: {
    username() {
      return '<span class="icon iconfont icon-user"></span>';
    }
  },
  props: {
    isForm: {
      type: Boolean,
      default: true
    }
  },
  mixins: [Size, Message]
};
</script>
<style scoped lang="less">
.formLogin {
  text-align: center;
  margin-bottom: 60px;
}
.formLogin img {
  width: 45%;
}
.border-input {
  width: 600px;
  padding: 0px 30px;
  border: 2px solid #fff;
  border-radius: 50px;
}
.input-remember-password {
  padding-top: 0px;
  border: none;
  width: 25px;
  height: 25px;
}
.el-checkbox {
  margin: 0px;
  text-align: left;
}
.el-checkbox /deep/ .el-checkbox__label {
  color: white;
  font-size: 20px;
}
.el-checkbox /deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
}

.el-checkbox /deep/ .el-checkbox__inner::after {
  height: 13px;
  width: 10px;
}
.el-checkbox /deep/ .el-checkbox__input {
  vertical-align: middle;
}

.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}
.blue-selected-color {
  color: @blue-selected-color;
}
.btn-operator {
  height: 50px;
  width: 200px;
  font-size: 23px;
}
.margin-top-10 {
  margin-top: 15px;
}
.margin-top-20 {
  margin-top: 30px;
}
.margin-top-30 {
  margin-top: 100px;
}
.margin-box {
  margin-left: 30px;
  width: 140px;
}
.btn-area {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-select .el-input__inner {
  font-size: 20px;
}
.select-http-https {
  /deep/ .el-input__inner {
    border-radius: 4px 0px 0px 4px;
  }
}
.input-server-port {
  /deep/ .el-input__inner {
    border-radius: 0px 4px 4px 0px;
  }
}
.input-server-ip {
  /deep/ .el-input__inner {
    border-radius: 0px;
  }
}
.icon-input {
  font-size: 35px;
  line-height: 50px;
}

.el-checkbox {
  margin-top: 5px;
  text-align: left;
  display: flex;
  align-items: center;
}
.el-checkbox /deep/ .el-checkbox__label {
  color: white;
  font-size: 25px;
}
.el-checkbox /deep/ .el-checkbox__inner {
  width: 30px;
  height: 30px;
}

.el-checkbox /deep/ .el-checkbox__inner::after {
  height: 21px;
  width: 12px;
  top: -1px;
  left: 6px;
  border-width: 4px;
}
.el-checkbox /deep/ .el-checkbox__input {
  vertical-align: middle;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #042ca4;
  border-color: #042ca4;
}
/deep/ .el-input-group__prepend {
  background-color: #2d3039;
  color: #ffffff;
  border-color: #ffffff;
  border: none;
}
// /deep/ .el-input-group__append {
//   background-color: #2d3039;
//   color: #ffffff;
//   border-color: #ffffff;
//   border-left: none;
// }
/deep/ .el-input__inner {
  width: 524px;
  height: 70px;
  background-color: #2d3039;
  color: #ffffff;
  border: none;
  border-color: #ffffff;
}
/deep/ .el-input__suffix {
  width: 50px;
  height: 70px;
  color: #fff;
  background-color: #2d3039;
  vertical-align: middle;
}
/deep/ .el-input .el-input__clear {
  width: 50px;
  color: #fff;
  font-size: 33px;
  cursor: pointer;
  padding-top: 2px;
}
/deep/ .el-button {
  width: 662px;
  height: 70px;
  line-height: 70px;
  border-radius: 50px;
  background-color: #042ca4;
  border-color: #042ca4;
}
.input_icon {
  width: 35px;
  padding-top: 16px;
}
.password-img {
  cursor: pointer;
  display: inline-block;
  width: 50px;
  height: 70px;
}
/deep/ .el-input__suffix-inner {
  display: inline-block;
  width: 50px;
  height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/FormLogin.vue